module.exports = __webpack_public_path__ + "static/media/icon-zusatzversicherung-blau.38dbffc5.svg";